import { render, staticRenderFns } from "./add-system.vue?vue&type=template&id=bd4d41d0&scoped=true"
import script from "./add-system.vue?vue&type=script&lang=js"
export * from "./add-system.vue?vue&type=script&lang=js"
import style0 from "./add-system.vue?vue&type=style&index=0&id=bd4d41d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4d41d0",
  null
  
)

export default component.exports